import { useState } from "react";
import { useNavigate } from "react-router";

import { Toast } from "@covertree/utils";

import {
  useCreateClaimMutation,
  useGetClaimUploadUrlsLazyQuery,
} from "@api/operations.generated";
import { useAppSelector } from "@redux/hooks";
import { StepPath } from "@routing/paths";

import { mapAppStateToCreateClaimInput, uploadFiles } from "./helpers";

export function useCreateClaim() {
  const navigate = useNavigate();
  const storeState = useAppSelector((state) => state);

  const [fileUploadLoading, setFileUploadLoading] = useState(false);

  const [createClaim, { error, loading: createClaimLoading }] =
    useCreateClaimMutation();
  const [getClaimUploadUrls, { loading: getUploadUrlsLoading }] =
    useGetClaimUploadUrlsLazyQuery();

  if (error) {
    Toast.showError(
      "An error occurred while submitting the claim. Please try again later."
    );
  }

  const handleSubmit = async () => {
    const { data } = await createClaim({
      variables: {
        createClaimInput: mapAppStateToCreateClaimInput(storeState),
      },
    });

    if (
      data?.createClaim?.claimLocator &&
      storeState.claimDocuments?.files.length > 0
    ) {
      const claimLocator = data.createClaim.claimLocator;
      const files = storeState.claimDocuments.files;

      const urlsResult = await getClaimUploadUrls({
        variables: {
          claimFiles: {
            claimLocator,
            fileNames: files.map((file) => file.name),
          },
        },
      });

      if (urlsResult?.data?.getClaimUploadUrls) {
        setFileUploadLoading(true);
        await uploadFiles(
          urlsResult.data.getClaimUploadUrls,
          storeState.claimDocuments.files
        );
        setFileUploadLoading(false);
      }

      navigate(`/${StepPath.CLAIM_SUBMITTED_SUCCESSFULLY}`);
    } else {
      navigate(`/${StepPath.CLAIM_SUBMITTED_SUCCESSFULLY}`);
    }
  };

  return {
    createClaim: handleSubmit,
    loading: createClaimLoading || getUploadUrlsLoading || fileUploadLoading,
  };
}
